import { useEffect, useState } from 'react';
import { createPortal } from 'react-dom';

interface Props {
  connection: 'connecting' | 'open' | 'closed';
}

export function ConnectionLost({ connection }: Props): React.ReactElement | null {
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    if (connection === 'open') {
      setVisible(false);
      return;
    }
    const t = setTimeout(() => setVisible(true), 4000);
    return () => clearTimeout(t);
  }, [connection]);

  if (!visible || connection === 'open') return null;

  return createPortal(
    <div className="conn-lost">
      <span>Reconnecting to the global game…</span>
      <button className="ghost" onClick={() => window.location.reload()}>Reload</button>
    </div>,
    document.body,
  );
}
